import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when request with socket was completed.
 * @memberOf Playtech.API.events
 * @event socket-response
 * @type {callback}
 * @param {object} detials
 * @param {number} details.requestId - Request ID.
 * @param {number} details.responseId - Response ID.
 * @param {number} details.time - Time it took to make the request is ms.
 * @example Playtech.on('socket-response', ({ requestId, responseId, time }) => { ... });
 */
export const SOCKET_RESPONSE = 'socket-response';

export const useOnSocketResponse = (eventTarget: EventTarget): void => {
    const triggerSocketResponseEvent = useCallback((detail: {
        requestId: number;
        responseId: number;
        time: number;
    }) => {
        const event = new CustomEvent(SOCKET_RESPONSE, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('socket-response', triggerSocketResponseEvent);

        return () => {
            publicEventsAPIService.off('socket-response', triggerSocketResponseEvent);
        };
    }, [triggerSocketResponseEvent]);
};
